import React, { useMemo } from 'react';
import { Text } from '@blueprint/ui';
import { TickMiniSmall } from '@blueprint/icons';

import TruncatedText from 'listing-details/components/TruncatedText/TruncatedText';

import {
    Description,
    FeaturesContainer,
    FeaturesList,
    HighlightedFeaturesList
} from './ListingFeatures.styles';
import { ListingFeaturesProps } from './ListingFeatures.types';
import { extractFeaturesFromQueryResponse } from './ListingFeatures.helpers';
import {
    trackExpandDescription,
    trackContractDescription
} from './ListingFeatures.tracking';

const ListingFeatures = ({ data }: ListingFeaturesProps) => {
    const { features, highlights } = extractFeaturesFromQueryResponse(data);
    const unescapedDescription = useMemo(
        () => (
            <span
                dangerouslySetInnerHTML={{
                    __html: data.detailedDescription || ''
                }}
            ></span>
        ),
        [data.detailedDescription]
    );

    return (
        <>
            <FeaturesContainer data-testid="listing_features">
                {highlights && highlights.length > 0 && (
                    <HighlightedFeaturesList data-testid="listing_features_highlighted">
                        {highlights.map((highlight) => (
                            <li key={highlight}>
                                <TickMiniSmall /> <Text>{highlight}</Text>
                            </li>
                        ))}
                    </HighlightedFeaturesList>
                )}
                {features && features.length > 0 && (
                    <FeaturesList data-testid="listing_features_bulletted">
                        {features.map((feature) => (
                            <li
                                key={feature}
                                dangerouslySetInnerHTML={{ __html: feature }}
                            />
                        ))}
                    </FeaturesList>
                )}
            </FeaturesContainer>
            <Description data-testid="listing_description">
                <TruncatedText
                    text={unescapedDescription}
                    lines={5}
                    labelExpanded="Hide full description"
                    labelContracted="See full description"
                    onExpand={trackExpandDescription}
                    onContract={trackContractDescription}
                />
            </Description>
        </>
    );
};

export default ListingFeatures;
